import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import styles from '@src/styles/components/menu-desktop.scss';
import MenuPrimaryPopup from './MenuPrimaryPopup';

export default class MenuPrimaryDesktop extends React.Component {

    static get propTypes() {

        return {
            anchor: PropTypes.string,
            link: PropTypes.string,
            items: PropTypes.any,
        };
    }

    render() {

        const { items } = this.props;

        return items
            ? this.renderPopup()
            : this.renderLink();
    }

    renderPopup() {

        const { anchor, items, link } = this.props;

        return (
            <div className={ css('menu-primary', styles) } key={ anchor }>
                <div>{ anchor }</div>
                <MenuPrimaryPopup items={ items } link={ link } />
            </div>
        );
    }

    renderLink() {

        const { anchor, link } = this.props;

        return (
            <div className={ css('menu-primary', styles)} key={ anchor }>
                <a href={ link } className={ css('flex items-center w-full h-full text-dark') }>
                    { anchor }
                </a>
            </div>
        );
    }

}